import {
  type ScheduleCollection,
  scheduleCollectionSchema,
  type Schedule,
  scheduleSchema, scheduleFilterSchema, type ScheduleFilter,
} from '@/types/Wiser/schedule.ts'

import { createRestApi, type HttpClient, type ModelApi } from '@jantm/model-core'

export type ScheduleApi = ModelApi<Schedule, ScheduleCollection, ScheduleFilter>

/**
 * The HTTP client is injected rather than imported so this package never pins
 * an axios instance, a base URL, or an auth interceptor — the host application
 * owns all three.
 */
export function createScheduleApi(
  client: HttpClient,
  endpoint = '/wiser/planning',
): ScheduleApi {
  return createRestApi({
    client,
    endpoint,
    schema: scheduleSchema,
    collectionSchema: scheduleCollectionSchema,
    filterSchema: scheduleFilterSchema,
  })
}
